import { Dialog, Box} from '@mui/material';

const SubscriptionModal = ({
  selectedAsset,
  subscriptionForm,
  closeSubsciptionModal,
  formErrors,
  formTouched,
  allFieldsValid,
  handleSubscriptionSubmit,
  handleSubscriptionChange,
  setShowSubscriptionForm,
  showSubscriptionForm,
  products,
}) => {
  return (
    <Dialog open={showSubscriptionForm} onClose={closeSubsciptionModal} maxWidth="lg" fullWidth>
      <Box p={3}>
        <div className="text-lg font-bold mb-4">Subscribe to {selectedAsset.name}</div>
        <form>
          <div className="form-grid">
            {/* <div className="form-section">
              <h2 className="section-title">Data Contract Terms</h2>
              <div className="info-line">
                <span className="info-label">Update Frequency:</span>
                <span className="info-value">Daily</span>
              </div>
              <div className="info-line">
                <span className="info-label">Quality Threshold:</span>
                <span className="info-value">95%</span>
              </div>
              <div className="info-line">
                <span className="info-label">Support SLA:</span>
                <span className="info-value">24 hours</span>
              </div>
            </div> */}
          <div className="grid [grid-template-columns:1fr_1fr] gap-2 p-2">
            <div className="mb-3">
              <label>Product Name <span className="text-red-500">*</span></label>
              <select 
                name="productName" 
                value={subscriptionForm.productName} 
                onChange={handleSubscriptionChange} 
                className="w-full border rounded p-2" 
              >
                <option value="">Select a product</option>
                {products?.map((option, index) => (
                  <option key={index} value={option}>{option}</option>
                ))}
              </select>
              {formTouched && formErrors.productName && <div className="text-red-500 text-xs">{formErrors.productName}</div>}
            </div>
            <div className="mb-3">
              <label>Project Code <span className="text-red-500">*</span></label>
              <input 
                name="projectCode" 
                value={subscriptionForm.projectCode} 
                onChange={handleSubscriptionChange} 
                placeholder="Enter Project Code"
                className="w-full border rounded p-2"
              />
              {formTouched && formErrors.projectCode && <div className="text-red-500 text-xs">{formErrors.projectCode}</div>}
            </div>
            <div className="mb-3">
              <label>Reader Group <span className="text-red-500">*</span></label>
              <input 
                name="readerGroup" 
                value={subscriptionForm.readerGroup} 
                onChange={handleSubscriptionChange} 
                placeholder="Enter Reader Group"
                className="w-full border rounded p-2"
              />
              {formTouched && formErrors.readerGroup && <div className="text-red-500 text-xs">{formErrors.readerGroup}</div>}
            </div>
            <div className="mb-3">
              <label>Usage Duration <span className="text-red-500">*</span></label>
              <select 
                name="usageDuration" 
                value={subscriptionForm.usageDuration} 
                onChange={handleSubscriptionChange} 
                className="w-full border rounded p-2" 
              >
                <option value="">Select Usage Duration</option>
                <option value="3months">3 Months</option>
                <option value="6months">6 Months</option>
                <option value="1year">1 Year</option>
              </select>
              {formTouched && formErrors.usageDuration && <div className="text-red-500 text-xs">{formErrors.usageDuration}</div>}
            </div>
            <div className="mb-3">
              <label>Usage Description <span className="text-red-500">*</span></label>
                <input 
                  type="textarea"
                  name="usageDescription" 
                  value={subscriptionForm.usageDescription} 
                  onChange={handleSubscriptionChange} 
                  placeholder="Describe how you plan to use this data"
                  className="w-full border rounded p-2" 
                />
                {formTouched && formErrors.usageDescription && <div className="text-red-500 text-xs">{formErrors.usageDescription}</div>}
            </div>
            <div className="mb-3">
              <label>Subscribe Email <span className="text-red-500">*</span></label>
              <input 
                type='email' 
                name="notificationEmail" 
                value={subscriptionForm.notificationEmail} 
                onChange={handleSubscriptionChange} 
                placeholder="Enter email (@aaysinsight.com)"
                className="w-full border rounded p-2" 
              />
              {formTouched && formErrors.notificationEmail && <div className="text-red-500 text-xs">{formErrors.notificationEmail}</div>}
              {!formTouched && subscriptionForm.notificationEmail && formErrors.notificationEmail && (
                <div className="text-red-500 text-xs mt-1">{formErrors.notificationEmail}</div>
              )}
            </div>
          </div>
          <div className="form-consent">
            <input
              type="checkbox"
              name="acceptTerms"
              checked={subscriptionForm.acceptTerms}
              onChange={handleSubscriptionChange}
            />
            <label>
                I agree to the data contract terms and will use the data in
                accordance with the specified quality requirements and usage
                guidelines.
            </label>
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <button type="button" onClick={closeSubsciptionModal} className="px-4 py-2 bg-gray-200 rounded" >Cancel</button>
            <button
              type="button"
              onClick={handleSubscriptionSubmit}
              className={`px-4 py-2 rounded ${!subscriptionForm.acceptTerms || !allFieldsValid ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#bb1ccc] text-white'}`}
              disabled={!subscriptionForm.acceptTerms || !allFieldsValid}
            >
              Subscribe
            </button>
          </div>          
          </div>
        </form>
      </Box>
    </Dialog>
  );
};

export default SubscriptionModal;
